// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: prFzY4CsJhDpFsYFo29VMf
// Component: bo0iK6sI80F7

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Header from "../../Header"; // plasmic-import: FX7sJMOvuD/component
import TextInput from "../../TextInput"; // plasmic-import: TAzASWLFePH/component
import Button from "../../Button"; // plasmic-import: MznF3tGFZjD/component
import Footer from "../../Footer"; // plasmic-import: WRs9bMrYcz/component

import { useScreenVariants as useScreenVariants_5VS0GwAl4 } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: -5vS0GW_al4/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_idea_hub.module.css"; // plasmic-import: prFzY4CsJhDpFsYFo29VMf/projectcss
import sty from "./PlasmicSubmitAProduct.module.css"; // plasmic-import: bo0iK6sI80F7/css

import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: f42r0km3yz4/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: OZSfMt1ZAhb/icon

createPlasmicElementProxy;

export type PlasmicSubmitAProduct__VariantMembers = {};
export type PlasmicSubmitAProduct__VariantsArgs = {};
type VariantPropType = keyof PlasmicSubmitAProduct__VariantsArgs;
export const PlasmicSubmitAProduct__VariantProps = new Array<VariantPropType>();

export type PlasmicSubmitAProduct__ArgsType = {};
type ArgPropType = keyof PlasmicSubmitAProduct__ArgsType;
export const PlasmicSubmitAProduct__ArgProps = new Array<ArgPropType>();

export type PlasmicSubmitAProduct__OverridesType = {
  root?: p.Flex<"div">;
  header?: p.Flex<typeof Header>;
  banner?: p.Flex<"div">;
  foreground2?: p.Flex<"div">;
  h1?: p.Flex<"h1">;
  clientsSection5?: p.Flex<"div">;
  formWrapper?: p.Flex<"div">;
  name2?: p.Flex<"div">;
  nameOfProductTextBox?: p.Flex<typeof TextInput>;
  urlOfProductTextBox?: p.Flex<typeof TextInput>;
  keyFeaturesTextBox?: p.Flex<"textarea">;
  emailTextBox?: p.Flex<typeof TextInput>;
  pricingTextBox?: p.Flex<"textarea">;
  socialsTextBox?: p.Flex<"textarea">;
  submitButton?: p.Flex<typeof Button>;
  footer?: p.Flex<typeof Footer>;
  toastPlaceHolder?: p.Flex<"div">;
};

export interface DefaultSubmitAProductProps {
  className?: string;
}

const $$ = {};

function PlasmicSubmitAProduct__RenderFunc(props: {
  variants: PlasmicSubmitAProduct__VariantsArgs;
  args: PlasmicSubmitAProduct__ArgsType;
  overrides: PlasmicSubmitAProduct__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "nameOfProductTextBox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "emailTextBox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "keyFeaturesTextBox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "pricingTextBox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "socialsTextBox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "urlOfProductTextBox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_5VS0GwAl4()
  });

  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Header
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            className={classNames("__wab_instance", sty.header)}
          />

          <div
            data-plasmic-name={"banner"}
            data-plasmic-override={overrides.banner}
            className={classNames(projectcss.all, sty.banner)}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"foreground2"}
              data-plasmic-override={overrides.foreground2}
              hasGap={true}
              className={classNames(projectcss.all, sty.foreground2)}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__etUoQ)}
              >
                <h1
                  data-plasmic-name={"h1"}
                  data-plasmic-override={overrides.h1}
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    projectcss.__wab_text,
                    sty.h1
                  )}
                >
                  {hasVariant(globalVariants, "screen", "mobileOnly")
                    ? "Submit a Product"
                    : "Submit a Product"}
                </h1>
              </p.Stack>
            </p.Stack>
          </div>
          <p.Stack
            as={"div"}
            data-plasmic-name={"clientsSection5"}
            data-plasmic-override={overrides.clientsSection5}
            hasGap={true}
            className={classNames(projectcss.all, sty.clientsSection5)}
          >
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__p5Fd3)}
            >
              <div className={classNames(projectcss.all, sty.columns__nsDc3)}>
                <div className={classNames(projectcss.all, sty.column___4Hnso)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__uRzYi
                    )}
                  >
                    {hasVariant(globalVariants, "screen", "mobileOnly")
                      ? "Whether you've developed a groundbreaking solution or discovered a valuable tool, we invite you to share it with our vibrant community and be part of the solution-oriented ecosystem we're building together."
                      : "Whether you've developed a groundbreaking solution or discovered a valuable tool, we invite you to share it with our vibrant community and be part of the solution-oriented ecosystem we're building together."}
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.column__ecnSo)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.columns___5SRpS)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.column__h46Qa)}
                    >
                      <div
                        data-plasmic-name={"formWrapper"}
                        data-plasmic-override={overrides.formWrapper}
                        className={classNames(projectcss.all, sty.formWrapper)}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.columns__fTsgL
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column___76K4C
                            )}
                          >
                            <div
                              data-plasmic-name={"name2"}
                              data-plasmic-override={overrides.name2}
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.name2
                              )}
                            >
                              {"Name of the product"}
                            </div>
                            <TextInput
                              data-plasmic-name={"nameOfProductTextBox"}
                              data-plasmic-override={
                                overrides.nameOfProductTextBox
                              }
                              className={classNames(
                                "__wab_instance",
                                sty.nameOfProductTextBox
                              )}
                              endIcon={
                                <ChecksvgIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__dtOjk
                                  )}
                                  role={"img"}
                                />
                              }
                              onChange={(...eventArgs) => {
                                p.generateStateOnChangeProp($state, [
                                  "nameOfProductTextBox",
                                  "value"
                                ])(
                                  (e => e.target?.value).apply(null, eventArgs)
                                );
                              }}
                              placeholder={""}
                              startIcon={
                                <SearchsvgIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__kvU
                                  )}
                                  role={"img"}
                                />
                              }
                              value={
                                p.generateStateValueProp($state, [
                                  "nameOfProductTextBox",
                                  "value"
                                ]) ?? ""
                              }
                            />
                          </div>
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.columns__fmgmK
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column__wluef
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__ucWFz
                              )}
                            >
                              {"URL of the product"}
                            </div>
                            <TextInput
                              data-plasmic-name={"urlOfProductTextBox"}
                              data-plasmic-override={
                                overrides.urlOfProductTextBox
                              }
                              className={classNames(
                                "__wab_instance",
                                sty.urlOfProductTextBox
                              )}
                              endIcon={
                                <ChecksvgIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__nsUni
                                  )}
                                  role={"img"}
                                />
                              }
                              onChange={(...eventArgs) => {
                                p.generateStateOnChangeProp($state, [
                                  "urlOfProductTextBox",
                                  "value"
                                ])(
                                  (e => e.target?.value).apply(null, eventArgs)
                                );
                              }}
                              placeholder={""}
                              startIcon={
                                <SearchsvgIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__gsMgh
                                  )}
                                  role={"img"}
                                />
                              }
                              value={
                                p.generateStateValueProp($state, [
                                  "urlOfProductTextBox",
                                  "value"
                                ]) ?? ""
                              }
                            />
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column___4Lku
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__nQb6M
                              )}
                            >
                              {"Key features of the product"}
                            </div>
                            <textarea
                              data-plasmic-name={"keyFeaturesTextBox"}
                              data-plasmic-override={
                                overrides.keyFeaturesTextBox
                              }
                              className={classNames(
                                projectcss.all,
                                projectcss.textarea,
                                sty.keyFeaturesTextBox
                              )}
                              onChange={e => {
                                p.generateStateOnChangeProp($state, [
                                  "keyFeaturesTextBox",
                                  "value"
                                ])(e.target.value);
                              }}
                              ref={ref => {
                                $refs["keyFeaturesTextBox"] = ref;
                              }}
                              value={
                                p.generateStateValueProp($state, [
                                  "keyFeaturesTextBox",
                                  "value"
                                ]) ?? ""
                              }
                            />
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column___0QxPr
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__xuEL
                              )}
                            >
                              {"Your email address"}
                            </div>
                            <TextInput
                              data-plasmic-name={"emailTextBox"}
                              data-plasmic-override={overrides.emailTextBox}
                              className={classNames(
                                "__wab_instance",
                                sty.emailTextBox
                              )}
                              endIcon={
                                <ChecksvgIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__kmAe
                                  )}
                                  role={"img"}
                                />
                              }
                              onChange={(...eventArgs) => {
                                p.generateStateOnChangeProp($state, [
                                  "emailTextBox",
                                  "value"
                                ])(
                                  (e => e.target?.value).apply(null, eventArgs)
                                );
                              }}
                              placeholder={""}
                              startIcon={
                                <SearchsvgIcon
                                  className={classNames(
                                    projectcss.all,
                                    sty.svg__mM3MR
                                  )}
                                  role={"img"}
                                />
                              }
                              value={
                                p.generateStateValueProp($state, [
                                  "emailTextBox",
                                  "value"
                                ]) ?? ""
                              }
                            />
                          </div>
                        </div>
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.columns__zoVqS
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column__pLDv3
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__jsj8U
                              )}
                            >
                              {"Pricing information (including discounts!) "}
                            </div>
                            <textarea
                              data-plasmic-name={"pricingTextBox"}
                              data-plasmic-override={overrides.pricingTextBox}
                              className={classNames(
                                projectcss.all,
                                projectcss.textarea,
                                sty.pricingTextBox
                              )}
                              onChange={e => {
                                p.generateStateOnChangeProp($state, [
                                  "pricingTextBox",
                                  "value"
                                ])(e.target.value);
                              }}
                              ref={ref => {
                                $refs["pricingTextBox"] = ref;
                              }}
                              value={
                                p.generateStateValueProp($state, [
                                  "pricingTextBox",
                                  "value"
                                ]) ?? ""
                              }
                            />
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.column__goWj8
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__n8CwP
                              )}
                            >
                              {
                                "Your socials/ anything else you want to promote. "
                              }
                            </div>
                            <textarea
                              data-plasmic-name={"socialsTextBox"}
                              data-plasmic-override={overrides.socialsTextBox}
                              className={classNames(
                                projectcss.all,
                                projectcss.textarea,
                                sty.socialsTextBox
                              )}
                              onChange={e => {
                                p.generateStateOnChangeProp($state, [
                                  "socialsTextBox",
                                  "value"
                                ])(e.target.value);
                              }}
                              ref={ref => {
                                $refs["socialsTextBox"] = ref;
                              }}
                              value={
                                p.generateStateValueProp($state, [
                                  "socialsTextBox",
                                  "value"
                                ]) ?? ""
                              }
                            />

                            <div
                              className={classNames(
                                projectcss.all,
                                sty.freeBox___06GW
                              )}
                            >
                              <Button
                                data-plasmic-name={"submitButton"}
                                data-plasmic-override={overrides.submitButton}
                                className={classNames(
                                  "__wab_instance",
                                  sty.submitButton
                                )}
                                color={"blue"}
                                endIcon={
                                  <ChecksvgIcon
                                    className={classNames(
                                      projectcss.all,
                                      sty.svg__iKwbb
                                    )}
                                    role={"img"}
                                  />
                                }
                                startIcon={
                                  <ChecksvgIcon
                                    className={classNames(
                                      projectcss.all,
                                      sty.svg__fpke3
                                    )}
                                    role={"img"}
                                  />
                                }
                                submitsForm={true}
                              >
                                <div
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.__wab_text,
                                    sty.text__aHmTd
                                  )}
                                >
                                  {"Submit"}
                                </div>
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </p.Stack>
                </div>
              </div>
            </p.Stack>
          </p.Stack>
          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
          />

          <div
            data-plasmic-name={"toastPlaceHolder"}
            data-plasmic-override={overrides.toastPlaceHolder}
            className={classNames(projectcss.all, sty.toastPlaceHolder)}
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "header",
    "banner",
    "foreground2",
    "h1",
    "clientsSection5",
    "formWrapper",
    "name2",
    "nameOfProductTextBox",
    "urlOfProductTextBox",
    "keyFeaturesTextBox",
    "emailTextBox",
    "pricingTextBox",
    "socialsTextBox",
    "submitButton",
    "footer",
    "toastPlaceHolder"
  ],
  header: ["header"],
  banner: ["banner", "foreground2", "h1"],
  foreground2: ["foreground2", "h1"],
  h1: ["h1"],
  clientsSection5: [
    "clientsSection5",
    "formWrapper",
    "name2",
    "nameOfProductTextBox",
    "urlOfProductTextBox",
    "keyFeaturesTextBox",
    "emailTextBox",
    "pricingTextBox",
    "socialsTextBox",
    "submitButton"
  ],
  formWrapper: [
    "formWrapper",
    "name2",
    "nameOfProductTextBox",
    "urlOfProductTextBox",
    "keyFeaturesTextBox",
    "emailTextBox",
    "pricingTextBox",
    "socialsTextBox",
    "submitButton"
  ],
  name2: ["name2"],
  nameOfProductTextBox: ["nameOfProductTextBox"],
  urlOfProductTextBox: ["urlOfProductTextBox"],
  keyFeaturesTextBox: ["keyFeaturesTextBox"],
  emailTextBox: ["emailTextBox"],
  pricingTextBox: ["pricingTextBox"],
  socialsTextBox: ["socialsTextBox"],
  submitButton: ["submitButton"],
  footer: ["footer"],
  toastPlaceHolder: ["toastPlaceHolder"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  header: typeof Header;
  banner: "div";
  foreground2: "div";
  h1: "h1";
  clientsSection5: "div";
  formWrapper: "div";
  name2: "div";
  nameOfProductTextBox: typeof TextInput;
  urlOfProductTextBox: typeof TextInput;
  keyFeaturesTextBox: "textarea";
  emailTextBox: typeof TextInput;
  pricingTextBox: "textarea";
  socialsTextBox: "textarea";
  submitButton: typeof Button;
  footer: typeof Footer;
  toastPlaceHolder: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSubmitAProduct__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSubmitAProduct__VariantsArgs;
    args?: PlasmicSubmitAProduct__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSubmitAProduct__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSubmitAProduct__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicSubmitAProduct__ArgProps,
          internalVariantPropNames: PlasmicSubmitAProduct__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSubmitAProduct__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSubmitAProduct";
  } else {
    func.displayName = `PlasmicSubmitAProduct.${nodeName}`;
  }
  return func;
}

export const PlasmicSubmitAProduct = Object.assign(
  // Top-level PlasmicSubmitAProduct renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    banner: makeNodeComponent("banner"),
    foreground2: makeNodeComponent("foreground2"),
    h1: makeNodeComponent("h1"),
    clientsSection5: makeNodeComponent("clientsSection5"),
    formWrapper: makeNodeComponent("formWrapper"),
    name2: makeNodeComponent("name2"),
    nameOfProductTextBox: makeNodeComponent("nameOfProductTextBox"),
    urlOfProductTextBox: makeNodeComponent("urlOfProductTextBox"),
    keyFeaturesTextBox: makeNodeComponent("keyFeaturesTextBox"),
    emailTextBox: makeNodeComponent("emailTextBox"),
    pricingTextBox: makeNodeComponent("pricingTextBox"),
    socialsTextBox: makeNodeComponent("socialsTextBox"),
    submitButton: makeNodeComponent("submitButton"),
    footer: makeNodeComponent("footer"),
    toastPlaceHolder: makeNodeComponent("toastPlaceHolder"),

    // Metadata about props expected for PlasmicSubmitAProduct
    internalVariantProps: PlasmicSubmitAProduct__VariantProps,
    internalArgProps: PlasmicSubmitAProduct__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicSubmitAProduct;
/* prettier-ignore-end */
